<div class="flex column wrapper">
  @if (!expandedElementDetails() && isLoading()) {
    <div class="skeleton-loader-details">
      <div class="skeleton-left">
        <div class="skeleton-line skeleton-title"></div>
        <div class="skeleton-line skeleton-text"></div>
        <div class="skeleton-line skeleton-text-short"></div>
        <div class="skeleton-line skeleton-text"></div>
        <div class="skeleton-line skeleton-text-medium"></div>
      </div>
      <div class="skeleton-right">
        <div class="skeleton-line skeleton-title"></div>
        <div class="skeleton-line skeleton-text"></div>
        <div class="skeleton-line skeleton-text-short"></div>
        <div class="skeleton-line skeleton-text"></div>
        <div class="skeleton-line skeleton-text-medium"></div>
        <div class="skeleton-line skeleton-text"></div>
      </div>
    </div>
  }
  @if (expandedElementDetails(); as details) {
    @if (
      details.payee_case.legal_relationship_files.length > 0 ||
      details.payee_case.legal_relationship_specification ||
      details.payee_case.description
    ) {
      <div class="left flex column grow1">
        <!-- Legal base -->
        @if (details.payee_case.legal_relationship_files.length > 0) {
          <div
            class="data-title"
            color="grey-dark"
          >
            {{ "CASE_DETAILS.LEGAL.TITLE" | translate }}
          </div>
          <div
            class="data-label-bold"
            color="grey-dark"
          >
            {{ "CASE_DETAILS.LEGAL.FILES_LABEL" | translate }}
          </div>
          <ul>
            @for (legalRelationshipFile of details.payee_case.legal_relationship_files; track legalRelationshipFile.storage_url) {
              <li
                class="data-value-bold"
                color="grey-dark"
              >
                <a
                  target="_blank"
                  color="grey-dark"
                  style="text-decoration: underline"
                  [href]="legalRelationshipFile.storage_url"
                >
                  {{ legalRelationshipFile.file_name }}
                </a>
              </li>
            }
          </ul>
        }
        @if (details.payee_case.legal_relationship_files.length > 0 && details.payee_case.description) {
          <hr />
        }
        @if (details.payee_case.description) {
          <div
            class="data-label-bold"
            color="grey-dark"
          >
            {{ "CASE_DETAILS.LEGAL.DESCRIPTION_LABEL" | translate }}
          </div>
          <div class="data-value">
            {{ details.payee_case.description }}
          </div>
        }
      </div>
    }
    <div class="right flex column grow1">
      @if (details.payee_case.bailiff_contact_url) {
        <div class="bailiff-contact-section">
          <div
            class="data-label-bold"
            color="grey-dark"
          >
            {{ "CASE_DETAILS.BAILIFF_CONTACT.TITLE" | translate }}
          </div>
          <a
            class="data-value-bold"
            rel="noopener noreferrer"
            target="_blank"
            color="grey-dark"
            style="text-decoration: underline"
            [href]="details.payee_case.bailiff_contact_url"
          >
            {{ details.payee_case.bailiff_contact_url }}
          </a>
        </div>
        <hr />
      }
      <!--Claims-->
      @if (details.claims.length > 0) {
        <div
          class="data-label-bold"
          color="grey-dark"
        >
          {{ "CASE_DETAILS.CLAIMS.CAPITAL_CLAIMS.TITLE" | translate }}
        </div>
        @for (claim of details.claims; track $index; let i = $index) {
          <div class="flex column claim">
            <div class="space-between vcenter">
              <div class="flex vcenter">
                <div class="flex claim-labels">
                  <div class="data-label-bold">
                    {{ "CASE_DETAILS.CLAIMS.CAPITAL_CLAIMS.INDEX" | translate: { index: i + 1 } }}
                  </div>
                  <div class="data-label">
                    {{ "CASE_DETAILS.CLAIMS.CAPITAL_CLAIMS.DUE_DATE_LABEL" | translate }}
                    {{ claim.due_date_at | date: "yyyy.MM.dd." }}
                  </div>
                </div>
              </div>
              <div class="data-value">
                <span>
                  {{ claim.remaining_amount | number: "1.0" : "hu" }}
                  {{ claim.currency }}
                </span>
                <span color="grey-dark">
                  &nbsp;/&nbsp;
                  {{ claim.original_amount | number: "1.0" : "hu" }}
                  {{ claim.currency }}
                </span>
              </div>
            </div>
            @for (claimFile of claim.files; track claimFile.storage_url) {
              <div class="flex vcenter">
                <div
                  class="data-label"
                  color="grey-dark"
                >
                  {{ "CASE_DETAILS.CLAIMS.CAPITAL_CLAIMS.FILE_TITLE" | translate }}&nbsp;
                </div>
                <a
                  class="data-value-bold"
                  color="grey-dark"
                  style="text-decoration: underline"
                  target="_blank"
                  [href]="claimFile.storage_url"
                >
                  {{ claimFile.file_name }}
                </a>
              </div>
            }
          </div>
        }
        <!-- Principal Claims Totals -->
        @if (details.displayed_claims_sums && (details.displayed_claims_sums | keyvalue).length > 0) {
          <div class="space-between">
            <div class="data-title-small">
              {{ "CASE_DETAILS.CLAIMS.CAPITAL_CLAIMS.TOTAL_LABEL" | translate }}
            </div>
            <div class="data-title-small">
              @for (sum of details.displayed_claims_sums | keyvalue; track sum.key; let last = $last) {
                <span>
                  {{ sum.value.remaining_amount | number: "1.0" : "hu" }}
                  {{ sum.key }}
                </span>
                <span color="grey-dark">
                  &nbsp;/&nbsp;
                  {{ sum.value.original_amount | number: "1.0" : "hu" }}
                  {{ sum.key }}
                </span>
                @if (!last) {
                  <span color="grey-dark">&nbsp;|&nbsp;</span>
                }
              }
            </div>
          </div>
        }
      }
      <!--Optional claims-->
      @if (details.hiddenClaims.length > 0) {
        @if (details.claims.length > 0) {
          <hr />
        }
        <div
          class="data-label-bold"
          color="grey-dark"
        >
          {{ "CASE_DETAILS.CLAIMS.OPTIONAL_CLAIMS.TITLE" | translate }}
        </div>
        @for (claim of details.hiddenClaims; track $index; let i = $index) {
          <div class="flex column claim">
            <div class="space-between vcenter">
              <div class="data-label-bold">{{ claim.label }}</div>
              <div class="data-value">
                <span>
                  {{ claim.remaining_amount | number: "1.0" : "hu" }}
                  {{ claim.currency }}
                </span>
                <span color="grey-dark">
                  &nbsp;/&nbsp;
                  {{ claim.original_amount | number: "1.0" : "hu" }}
                  {{ claim.currency }}
                </span>
              </div>
            </div>
          </div>
        }
        <!-- Hidden Claims Totals -->
        @if (details.hidden_claims_sums && (details.hidden_claims_sums | keyvalue).length > 0) {
          <div class="space-between">
            <div class="data-title-small">
              {{ "CASE_DETAILS.CLAIMS.OPTIONAL_CLAIMS.TOTAL_LABEL" | translate }}
            </div>
            <div class="data-title-small">
              @for (sum of details.hidden_claims_sums | keyvalue; track sum.key; let last = $last) {
                <span>
                  {{ sum.value.remaining_amount | number: "1.0" : "hu" }}
                  {{ sum.key }}
                </span>
                <span color="grey-dark">
                  &nbsp;/&nbsp;
                  {{ sum.value.original_amount | number: "1.0" : "hu" }}
                  {{ sum.key }}
                </span>
                @if (!last) {
                  <span color="grey-dark">&nbsp;|&nbsp;</span>
                }
              }
            </div>
          </div>
        }
      }
      <!-- All Claims Totals -->
      @if (details.claims_sums && (details.claims_sums | keyvalue).length > 0) {
        <hr />
        <div class="space-between">
          <div class="data-title data-title--total">
            {{ "CASE_DETAILS.CLAIMS.TOTAL_LABEL" | translate }}
          </div>
          <div class="data-title data-title--total">
            @for (sum of details.claims_sums | keyvalue; track sum.key; let last = $last) {
              <span>
                {{ sum.value.remaining_amount | number: "1.0" : "hu" }}
                {{ sum.key }}
              </span>
              <span color="grey-dark">
                &nbsp;/&nbsp;
                {{ sum.value.original_amount | number: "1.0" : "hu" }}
                {{ sum.key }}
              </span>
              @if (!last) {
                <span color="grey-dark">&nbsp;|&nbsp;</span>
              }
            }
          </div>
        </div>
      }
      <!--Documents & external identifiers-->
      @if (
        details.proforma_invoices.length > 0 ||
        details.invoices.length > 0 ||
        details.external_ids.length > 0 ||
        details.payee_case.payee_case_reference_id
      ) {
        <hr />
        <div class="data-title data-title--total">
          {{ "CASE_DETAILS.DOCUMENTS.TITLE" | translate }}
        </div>
        @if (details.invoices.length > 0) {
          <div
            class="data-label-bold"
            color="grey-dark"
          >
            {{ "CASE_DETAILS.DOCUMENTS.INVOICE_LABEL" | translate }}
          </div>
          @for (invoice of details.invoices; track invoice.storage_url) {
            <a
              class="document-link data-value-bold"
              target="_blank"
              rel="noopener noreferrer"
              color="grey-dark"
              [href]="invoice.storage_url"
            >
              <payee-icon
                name="document"
                width="16px"
                height="16px"
              ></payee-icon>
              <span>{{ invoice.file_name }}</span>
            </a>
          }
        }
        @if (details.proforma_invoices.length > 0) {
          <div
            class="data-label-bold"
            color="grey-dark"
          >
            {{ "CASE_DETAILS.DOCUMENTS.PROFORMA_LABEL" | translate }}
          </div>
          @for (proforma of details.proforma_invoices; track proforma.storage_url) {
            <a
              class="document-link data-value-bold"
              target="_blank"
              rel="noopener noreferrer"
              color="grey-dark"
              [href]="proforma.storage_url"
            >
              <payee-icon
                name="document"
                width="16px"
                height="16px"
              ></payee-icon>
              <span>{{ proforma.file_name }}</span>
            </a>
          }
        }
        @if (details.external_ids.length > 0 || details.payee_case.payee_case_reference_id) {
          <div
            class="data-label-bold"
            color="grey-dark"
          >
            {{ "CASE_DETAILS.DOCUMENTS.EXTERNAL_IDS_LABEL" | translate }}
          </div>
        }
        @if (details.payee_case.payee_case_reference_id) {
          <div class="flex vcenter identifier-row">
            <div
              class="data-label identifier-label-with-tooltip"
              color="grey-dark"
              matTooltipPosition="below"
              matTooltipShowDelay="0"
              matTooltipClass="info-tooltip"
              [matTooltip]="'CASE_DETAILS.DOCUMENTS.PAYEE_ID_TOOLTIP' | translate"
            >
              {{ "CASE_DETAILS.DOCUMENTS.PAYEE_ID_LABEL" | translate }}:&nbsp;
            </div>
            <div class="data-value-bold">
              {{ details.payee_case.payee_case_reference_id }}
            </div>
            <button
              type="button"
              class="copy-identifier-button"
              [attr.aria-label]="'CASE_DETAILS.COPY' | translate"
              (click)="copyText(details.payee_case.payee_case_reference_id, 'CASE_DETAILS.DOCUMENTS.PAYEE_ID_LABEL')"
            >
              <payee-icon
                name="copy-blue"
                width="14px"
                height="14px"
              ></payee-icon>
            </button>
          </div>
        }
        @for (externalId of details.external_ids; track externalId.type) {
          <div class="flex vcenter identifier-row">
            <div
              class="data-label"
              color="grey-dark"
              matTooltipPosition="below"
              matTooltipShowDelay="0"
              matTooltipClass="info-tooltip"
              [class.identifier-label-with-tooltip]="externalId.type === 'ofp'"
              [matTooltip]="externalId.type === 'ofp' ? ('CASE_DETAILS.DOCUMENTS.OFP_ID_TOOLTIP' | translate) : ''"
              [matTooltipDisabled]="externalId.type !== 'ofp'"
            >
              {{ "CASE_DETAILS.DOCUMENTS.EXTERNAL_ID_TYPE." + externalId.type | translate }}:&nbsp;
            </div>
            <div class="data-value-bold">
              {{ externalId.value }}
            </div>
            <button
              type="button"
              class="copy-identifier-button"
              [attr.aria-label]="'CASE_DETAILS.COPY' | translate"
              (click)="copyText(externalId.value, 'CASE_DETAILS.DOCUMENTS.EXTERNAL_ID_TYPE.' + externalId.type)"
            >
              <payee-icon
                name="copy-blue"
                width="14px"
                height="14px"
              ></payee-icon>
            </button>
          </div>
        }
      }
      <!--History-->
      @if (showParent()) {
        <div class="data-title">
          {{ "CASE_DETAILS.HISTORY.TITLE" | translate }}
        </div>
        @for (history of details.payee_case.history; track history.payee_case_reference_id; let i = $index) {
          <div class="flex vcenter parent-row">
            <div class="data-label-bold">{{ i + 1 }}.</div>
            <a
              class="data-value"
              (click)="filterToHistoricCase(history)"
            >
              {{ history.payee_case_reference_id }}
            </a>
            <div class="data-value">
              {{ history.stage_label }}
            </div>
            @if (history.started_at) {
              <div class="data-value">
                {{ "CASE_DETAILS.HISTORY.STARTED_AT" | translate }}
                {{ history.started_at | date: "yyyy.MM.dd. HH:mm" }}
              </div>
            }
          </div>
        }
      }
    </div>
  }
</div>
